var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c("div", { staticClass: "row explanation" }, [
        _vm.motd.enabled == 1
          ? _c(
              "div",
              {
                staticClass: "motd",
                class: {
                  warning: _vm.motd.type == "warning",
                  alert: _vm.motd.type == "alert"
                }
              },
              [
                _vm.motd.type == "alert"
                  ? _c("div", { staticClass: "motd-title" }, [
                      _vm._v("Belangrijke waarschuwing")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.motd.type == "warning"
                  ? _c("div", { staticClass: "motd-title" }, [
                      _vm._v("Waarschuwing")
                    ])
                  : _vm._e(),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.motd.message) +
                    "\n            "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.$root.app.platform == "android"
        ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
        : _vm._e(),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("div", { staticClass: "row row-single setting" }, [
        _vm.$root.app.platform == "android"
          ? _c("div", { staticClass: "col col-100" }, [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Klantenservice")
              ]),
              _c("br"),
              _vm._v(" "),
              _vm.support
                ? _c("span", { staticClass: "row__subtitle" }, [
                    _vm._v("Geopend")
                  ])
                : _c("span", { staticClass: "row__subtitle" }, [
                    _vm._v("Gesloten")
                  ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c("div", { staticClass: "col col-70" }, [
              _c("span", { staticClass: "row__title" }, [
                _vm._v("Klantenservice")
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$root.app.platform == "ios"
          ? _c("div", { staticClass: "col col-30" }, [
              _vm.support
                ? _c("span", { staticClass: "row__subtitle" }, [
                    _vm._v("Geopend")
                  ])
                : _c("span", { staticClass: "row__subtitle" }, [
                    _vm._v("Gesloten")
                  ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row spacer" }, [_vm._v(" ")]),
      _vm._v(" "),
      _vm._m(4),
      _vm._v(" "),
      _c("div", { staticClass: "row row-single setting has-subitem" }, [
        _c("div", { staticClass: "col col-100", on: { click: _vm.create } }, [
          _c("span", { staticClass: "row__title" }, [
            _vm._v("Nieuwe vraag stellen")
          ])
        ])
      ]),
      _vm._v(" "),
      _vm._l(_vm.tickets, function(item, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: item.typeId != 4,
                expression: "item.typeId != 4"
              }
            ],
            staticClass: "row setting has-subitem ticket-preview",
            class: { "row-last": _vm.tickets.length - 1 === index }
          },
          [
            _c(
              "router-link",
              { attrs: { to: "/feedback/ticket/" + item.id } },
              [
                _c("div", { staticClass: "col-status" }, [
                  _c("span", {
                    staticClass: "status",
                    class: "status--" + item.statusId
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col col-info" }, [
                  _c("div", { staticClass: "row__title" }, [
                    _vm._v(
                      "\n                        " + _vm._s(item.subject) + " "
                    ),
                    _c("br"),
                    _c("span", { staticClass: "ticket-preview__time" }, [
                      _vm._v(_vm._s(item.creationTime))
                    ]),
                    _vm._v(" "),
                    item.newMessages
                      ? _c("span", { staticClass: "new-messages" }, [
                          _vm._v(_vm._s(item.newMessages))
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.$root.app.platform == "ios"
        ? _c("div", { staticClass: "row spacer" }, [_vm._v(" ")])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [
        _vm._v("Status van het systeem")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row row-first setting system" }, [
      _c("div", { staticClass: "col col-80" }, [
        _c("span", { staticClass: "row__title" }, [_vm._v("Bellen")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-20" }, [
        _c("span", { staticClass: "status status--3" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row row-last setting system" }, [
      _c("div", { staticClass: "col col-80" }, [
        _c("span", { staticClass: "row__title" }, [_vm._v("Gegevens beheren")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col col-20" }, [
        _c("span", { staticClass: "status status--3" })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Helpcentrum")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row head" }, [
      _c("div", { staticClass: "col col-100" }, [_vm._v("Support tickets")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a7134532", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a7134532","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tickets.vue
// module id = null
// module chunks = 